import React from 'react';
import styled from 'styled-components';
import Spacer from './Spacer';

const Container = styled.div`
  display: flex;
  align-items: center;
`;

const Image = styled.div`
  width: 40px;
  height: 40px;
  min-width: 40px;
  border-radius: 10px;
  background-size: cover;
  background-position: center;
  box-shadow: 0px 3px 6px #00000012;
`;

const Content = styled.div``;

const Title = styled.div`
  font-weight: 400;
  font-size: 15px;
`;

const ExtraInfo = styled.div``;

type Props = {
  title: string;
  imageURL?: string;
  extraInfo?: string | React.ReactNode;
  className?: string;
};

export function ImageIcon({ title, imageURL, extraInfo, className }: Props) {
  return (
    <Container className={className}>
      <Image style={{ backgroundImage: `url(${imageURL})` }} />
      <Spacer horizontal spacing={2} />
      <Content>
        <Title>{title}</Title>
        {extraInfo && <ExtraInfo>{extraInfo}</ExtraInfo>}
      </Content>
    </Container>
  );
}
